import { Moment } from 'moment';
import { Ruleset } from '../../../../common/enums/Ruleset';

export class ReportVersion {
  constructor(private readonly id: number, private readonly name: string, private readonly date: Moment, private readonly ruleset: Ruleset | null) {}

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getDate() {
    return this.date;
  }

  getRuleset() {
    return this.ruleset;
  }
}
